import React from "react";
import ReactDOM from "react-dom/client";
// import App from "./App.tsx";
import "./index.css";
import MainLayout from "@freyr/freyr-add-in-frame";
import "@freyr/freyr-add-in-frame/dist/style.css";

console.log("integrated: ", __INTEGRATED__)

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <MainLayout
      authBasicUrl={import.meta.env?.["VITE_AUTH_API_GATEWAY"]}
      portalUrl={import.meta?.env?.["VITE_PORTAL_URL"]}
      customModules={[
        {
          key: "content",
          data: {
            CompDefinition: () => import("./index"),
            innerRoutePath: "content-path",
            desc: "Generate medical documentation",
            envVars: {
              VITE_CONTENT_API_GATEWAY: import.meta.env?.[
                "VITE_CONTENT_API_GATEWAY"
              ],
              VITE_CONTENT_WEB_DOMAIN: import.meta.env?.[
                "VITE_CONTENT_WEB_DOMAIN"
              ],
            },
          },
        },
        {
          key: "partner",
          data: {
            CompDefinition: () => import("./components/MockModuleComp"),
            innerRoutePath: "partner-path",
            desc: "Query, extract the needed information from the document",
          },
        },
        {
          key: "dossier",
          data: {
            CompDefinition: () => import("./components/MockModuleComp"),
            innerRoutePath: "dossier-path",
            desc: "Validate, generate contents based on the document",
          },
        },
        {
          key: "rtq",
          data: {
            CompDefinition: () => import("./components/MockModuleComp"),
            innerRoutePath: "rtq-path",
            desc: "Get your answers for health authority questions",
          },
        },
      ]}
      frameConfig={{
        privacyUrl: import.meta.env?.["VITE_PRIVACY_URL"],
        termOfUseUrl: import.meta.env?.["VITE_TERM_OF_USE_URL"],
        contactUsUrl: import.meta.env?.["VITE_CONTACT_US_URL"],
        helpUrl: import.meta.env?.["VITE_HELP_URL"],
      }}
    />
  </React.StrictMode>
);
